// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"334":"app-theme-dark1","522":"app-theme-dark0","554":"app-theme-light1","641":"app-theme-light0"}[chunkId] + "." + {"334":"0e83a4bc","522":"cabb6038","554":"e53887fd","641":"ba26cc91"}[chunkId] + ".chunk.css";
};